import { render } from "./UIExampleIncompleteNotice.vue?vue&type=template&id=278750a1&ts=true"
import script from "./UIExampleIncompleteNotice.vue?vue&type=script&lang=ts"
export * from "./UIExampleIncompleteNotice.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__